import { IPricing } from 'src/app/shared/responses/ipricing';
import packageJson from '../../package.json';

export const environment = {
	appVersion: packageJson.version.replace('-', '.').replace('+', '.'),
	production: false,
	name: 'dev'
};

export const appConfig = {
	apiRoot: 'https://lehgaity0c.execute-api.ap-southeast-1.amazonaws.com/dev/api',
	logger: 'https://lehgaity0c.execute-api.ap-southeast-1.amazonaws.com/dev/api/logs',
	uiCustomizations: 'https://lehgaity0c.execute-api.ap-southeast-1.amazonaws.com/dev/api/uicustomizations',
	logSource: 'Trackinator.Spa',
	applicationName: 'Trackinator',
	localDbName: 'f2e89f26890d487f829923b84f4a7b3f',
};

export const auth0Config = {
	identityServer: 'https://eml-solutions.auth0.com/',     			// changes here should also be applied in silent-callback.html
	identityServerClientId: 'zOwyQAuaL1zn6avmnWXrY6UuzG545uuB', // changes here should also be applied in silent-callback.html
	apiIdentifier: '506068d5-fcc4-4a2a-9586-4d48ee04f173',
	apiScope: 'openid profile trackinator-api-scope email given_name',  							// changes here should also be applied in silent-callback.html
};

export const appUrl = {
	REGEX_PATTERN_URL: /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/,
	userProfile: `${appConfig.apiRoot}/profiles/user`,
	userProfileImage: `${appConfig.apiRoot}/profiles/userimage`, // Put
	guestProfile: `${appConfig.apiRoot}/profiles/guest`,
	guestPricing: `${appConfig.apiRoot}/profiles/guest/pricing`,
	pabblyMonthlyCheckout: `https://payments.pabbly.com/subscribe/5f40466235a5d50a20457bf5/trackinator-basic`,
	pabblyMonthlySubscribe: `https://payments.pabbly.com/subscribe/`,
	pabblyYearlySubscribe: `https://payments.pabbly.com/subscribe/`,
	pabblyVerifyCheckout: `${appConfig.apiRoot}/subscriptions/verify`,
};

export const MenuLocation = {
	topRight: `topRight`,
};

export const Pricing: IPricing = {
	plansMonthly: [
		{
			planGroup: '5f40466235a5d50a20457bf5/trackinator-basic', // changes here should be applied to pabblyMonthlyCheckout also.
			planId: '5f40466235a5d50a20457bf5',
			amount: 1000,
			trackerCount: 100,
			planName: 'basic',
			description: 'Simplest package to get you started',
			trial: 5,
			buttonCaption: 'Buy now'
		},
		{
			planGroup: '5f42e40335a5d50a2045960b/trackinator-silver',
			planId: '5f42e40335a5d50a2045960b',
			amount: 1800,
			trackerCount: 200,
			planName: 'silver',
			description: 'The most popular package we offer',
			buttonCaption: 'Buy now'
		},
		{
			planGroup: '5f42e4c335a5d50a2045960c/trackinator-gold',
			planId: '5f42e4c335a5d50a2045960c',
			amount: 4000,
			trackerCount: 500,
			planName: 'gold',
			description: 'The perfect package for your small business',
			buttonCaption: 'Buy now'
		},
		{
			planGroup: '5f52a0ac72b8da13f080eee3/trackinator-platinum',
			planId: '5f52a0ac72b8da13f080eee3',
			amount: 7000,
			trackerCount: 1000,
			planName: 'platinum',
			description: 'Our most advanced & complete package',
			buttonCaption: 'Buy now'
		}
	],
	plansYearly: [
		{
			planGroup: '5f52a27872b8da13f080eefd/trackinator-basic',
			planId: '5f52a27872b8da13f080eefd',
			amount: 12000,
			trackerCount: 1440,
			planName: 'basic',
			description: 'Simplest package to get you started',
			buttonCaption: 'Buy now'
		},
		{
			planGroup: '5f52a2fc72b8da13f080eefe/trackinator-silver',
			planId: '5f52a2fc72b8da13f080eefe',
			amount: 21600,
			trackerCount: 2880,
			planName: 'silver',
			description: 'The most popular package we offer',
			buttonCaption: 'Buy now'
		},
		{
			planGroup: '5f52a34c72b8da13f080ef02/trackinator-gold',
			planId: '5f52a34c72b8da13f080ef02',
			amount: 48000,
			trackerCount: 7200,
			planName: 'gold',
			description: 'The perfect package for your small business',
			buttonCaption: 'Buy now'
		},
		{
			planGroup: '5f52a39f72b8da13f080ef04/trackinator-platinum',
			planId: '5f52a39f72b8da13f080ef04',
			amount: 84000,
			trackerCount: 14400,
			planName: 'platinum',
			description: 'Our most advanced & complete package',
			buttonCaption: 'Buy now'
		}
	],
	topUp: {
		planGroup: 'top-up-100',
		planId: '5f60ab279a19cd55a45bc8ff',
		amount: 1000,
		trackerCount: 100,
		planName: 'top-up-100',
		description: 'Top-up 100 MORE!',
		buttonCaption: 'Top-up 100'
	},
	currentSubscription: '',
	baseCostPerTracker: 10
};
